import React, { useEffect, useState,useCallback,useRef } from "react";
import AxiosInstance from '../AxiosInstance';
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Layout from './Layout';
import { FaTrash } from 'react-icons/fa';
import Pagination from "../Pagination";
import ToastNotification from "../ToastNotification";

const Projects = () => {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [newProject, setNewProject] = useState({ project_name: "" });
  const [assignedEmployees, setAssignedEmployees] = useState([]);
  const [allEmployees, setAllEmployees] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); 
  const [filteredProjects, setFilteredProjects] = useState([]); 
  const [account, setAccount] = useState([]);
  const toastRef = useRef(null);
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    setCurrentPage(1);
  
    const filtered = projects.filter((project) =>
      project.project_name.toLowerCase().includes(term)
    );
    setFilteredProjects(filtered);
  };
  useEffect(() => {
    if (!searchTerm) {
      setFilteredProjects(projects); 
    }
  }, [projects, searchTerm]);  
    
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const fetchProjects = useCallback(async () => {
    try {
      const response = await AxiosInstance.get(`/admin/projects?page=${currentPage}&search=${searchTerm}`);
      setProjects(response.data.projects);  
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
       toastRef.current?.showToast("Error fetching projects:", "danger");
    }
  }, [currentPage, searchTerm]); //Dependencies added
  
  // Fetch employees (no changes needed)
  const fetchEmployees = async () => {
    try {
      const response = await AxiosInstance.get("/admin/employees");
      if (response.data && Array.isArray(response.data.employees)) {
        setAllEmployees(
          response.data.employees.map((emp) => ({
            label: emp.username,
            value: emp.user_id,
          }))
        );
      } else {
        toastRef.current?.showToast("Unexpected response format:", response.data,"danger");
      }
    } catch (error) {
      toastRef.current?.showToast("Error fetching employees:","danger");
    }
  };
  
  //useEffect now includes fetchProjects safely
  useEffect(() => {
    fetchProjects();
    fetchEmployees();
  }, [fetchProjects]);

  // Delete a project
  const deleteProject = async (project_id) => {
    try {
        const response = await AxiosInstance.delete(`/admin/deleteProject/${project_id}`);
        console.log("Response from delete API:", response); // Debugging  

        if (response?.status === 200 && response?.data === "Project removed successfully") {
            toastRef.current.showToast("Project deleted successfully!", "success"); 
            
            // Fetch updated project list after deletion
            await fetchProjects(); 
        } else {
            toastRef.current.showToast("Error deleting project.", "danger");
        }
    } catch (error) {
        toastRef.current.showToast("Error deleting project.", "danger");
    }
};

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        const response = await AxiosInstance.get("/common/accounts");
        setAccount(response.data); 
      } catch (error) {
        toastRef.current?.showToast("Error fetching accounts:", "danger");
      }
    };
    fetchAccount();
  }, []);
  
  // Add a new project
  const handleAddProject = async (e) => {
    e.preventDefault();
    
    const projectData = {
      account: newProject.account,
      project_name: newProject.project_name,
      start_date: newProject.start_date,
      end_date: newProject.end_date,
      assignedEmployees: assignedEmployees.map((emp) => emp.value),
    };
  
    try {
      const response = await AxiosInstance.post("/admin/addProject", projectData);
      if (response.status === 200) {
        toastRef.current.showToast("Project added successfully!", "success");
        
        setNewProject({ account: "", project_name: "", start_date: "", end_date: "" });
        setAssignedEmployees([]);
        setShowForm(false);
        fetchProjects();  
      } else {
        toastRef.current.showToast("Error adding project.", "danger");
      }
    } catch (error) {
      toastRef.current.showToast("Error adding project.", "danger"); 
    }
};


  return (
    <Layout heading="Projects">
      <div className="container">
        {/* Search + Add Button Row */}
<div className="row align-items-center justify-content-between mb-4">
  {/* Search Bar */}
  <div className="col-12 col-md-6 col-lg-4 mb-2 mb-md-0">
    <div className="input-group">
      <span className="input-group-text">
        <i className="bi bi-search text-secondary"></i>
      </span>
      <input
        type="text"
        className="form-control"
        placeholder="Search Projects..."
        value={searchTerm}
        onChange={handleSearch}
      />
    </div>
  </div>

  {/* Add Button */}
  <div className="col-12 col-md-6 col-lg-auto text-md-end">
    <button
      className="btn btn-primary w-100 w-md-auto px-4 mt-2 mt-md-0"
      onClick={() => setShowForm(!showForm)}
    >
      {showForm ? "Close Form" : "Add New Project"}
    </button>
  </div>
</div>


        {showForm && (
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="card p-4 mb-4">
                <h4 className="text-center text-primary">Add New Project</h4>
                
                <form onSubmit={handleAddProject}>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">Account</label>
                      <select
                        className="form-select"
                        value={newProject.account || ""}
                        onChange={(e) => setNewProject({ ...newProject, account: e.target.value })}
                        required
                      >
                        <option value="" disabled>Select Account</option>
                        {account.map((acc) => (
                          <option key={acc.account_id} value={acc.account_id}>
                            {acc.account_value}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Project Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={newProject.project_name}
                        onChange={(e) => setNewProject({ ...newProject, project_name: e.target.value })}
                        placeholder="Enter project name"
                        required
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={newProject.start_date}
                        onChange={(e) => setNewProject({ ...newProject, start_date: e.target.value })}
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={newProject.end_date}
                        onChange={(e) => setNewProject({ ...newProject, end_date: e.target.value })}
                        required
                      />
                    </div>
                  </div>

                  {/* Assign Employees */}
                  <div className="mb-3">
                    <label className="form-label">Assign Employees</label>
                    <Select
                      isMulti
                      options={allEmployees}
                      value={assignedEmployees}
                      onChange={(selectedOptions) => setAssignedEmployees(selectedOptions || [])}
                      placeholder="Select employees"
                      className="react-select-container"
                      classNamePrefix="react-select"
                    />
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn btn-primary w-50">Add Project</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
        {/* Table Section */}
        <div className="row mt-3">
          <div className="col">
            <div className="table-responsive">
              <table className="table table-hover text-center align-middle table-striped">
                <thead className="table-primary">
                  <tr>
                    <th>#</th>
                    <th className="text-start">Project Name</th>
                    <th className="text-start">Account</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredProjects.length > 0 ? (
                    filteredProjects.map((project, index) => (
                      <tr key={project.project_id}>
                        <td>{(currentPage - 1) * 5 + index + 1}</td>
                        <td
                          className="text-start"
                          onClick={() => navigate(`/editproject/${project.project_id}`)}
                          style={{ cursor: "pointer" }}
                        >
                          {project.project_name.replace(/\b\w/g, char => char.toUpperCase())}
                        </td>
                        <td className="text-start">
                          {project.account_value ? project.account_value[0].toUpperCase() + project.account_value.slice(1) : "N/A"}
                        </td>
                        <td>
                          <button className="btn btn-danger btn-sm" onClick={() => deleteProject(project.project_id)}>
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-muted">No projects found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
          <div className="col-auto">
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
          </div>
        </div>
        <ToastNotification ref={toastRef} />

    </Layout>
  );
};

export default Projects;
